import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { communityApi as defaultApi } from '../../community/community-api';
import { PageState } from '../../components/PageState';

export function ReportsPage({ api = defaultApi }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    setHasLoaded(false);
    setError('');
    api.listReports('open')
      .then(result => { setReports(result.reports || []); setHasLoaded(true); })
      .catch(() => setError('No se pudieron cargar las denuncias.'))
      .finally(() => setLoading(false));
  }, [api]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <PageState title="Denuncias de Comunidad" status="loading" message="Cargando denuncias…" />;
  if (!hasLoaded && error) return <PageState
    title="Denuncias de Comunidad"
    status="error"
    message={error}
    action={<button type="button" className="gym-button gym-button--primary" onClick={load}>Reintentar</button>}
  />;
  if (hasLoaded && reports.length === 0) return <PageState title="Denuncias de Comunidad" status="empty" message="No hay denuncias pendientes.">
    <p className="gym-admin-community-reports__count">Pendientes · 0</p>
  </PageState>;

  async function resolve(report) {
    if (busyId) return;
    setBusyId(report.id);
    setError('');
    try {
      await api.resolveReport(report.id);
      setReports(current => current.filter(entry => entry.id !== report.id));
    } catch {
      setError('No se pudo resolver la denuncia.');
    } finally {
      setBusyId(null);
    }
  }

  return <section className="gym-page" aria-labelledby="community-reports-title">
    <h1 id="community-reports-title" className="gym-page__title">Denuncias de Comunidad</h1>
    {hasLoaded && <p className="gym-admin-community-reports__count">Pendientes · {reports.length}</p>}
    {error && <p role="alert">{error}</p>}
    <div className="gym-admin-community-reports">
      {reports.map(report => <article className="gym-card gym-admin-community-reports__card" key={report.id}>
        <div className="gym-admin-community-reports__reason"><span>Motivo</span><p>{report.reason}</p></div>
        <div className="gym-admin-community-reports__reporter"><span>Reportó</span><strong>{report.reporter?.username || 'Socio'}</strong></div>
        {report.post && <blockquote>{report.post.body}</blockquote>}
        {report.comment && <blockquote>{report.comment.body}</blockquote>}
        <div className="gym-admin-community-reports__actions">
        {(report.postId || report.post?.id || report.comment?.postId) && <Link className="gym-button gym-button--secondary" to={`/comunidad/publicacion/${report.comment?.postId || report.postId || report.post?.id}${report.commentId ? `?comentario=${encodeURIComponent(report.commentId)}` : ''}`}>
          {report.commentId ? 'Ver comentario' : 'Ver publicación'}
        </Link>}
        <button type="button" className="gym-button gym-button--primary" disabled={busyId !== null} onClick={() => resolve(report)}>
          {busyId === report.id ? 'Resolviendo…' : 'Resolver denuncia'}
        </button>
        </div>
      </article>)}
    </div>
    {!loading && hasLoaded && error && <button type="button" className="gym-button gym-button--secondary" onClick={load}>Reintentar</button>}
  </section>;
}
